import { render, staticRenderFns } from "./ListContractView.vue?vue&type=template&id=2af1e304"
import script from "./ListContractView.vue?vue&type=script&lang=ts"
export * from "./ListContractView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports